// Mobile numbers on the site are Indian, entered as their 10 digits (the "+91" is shown, not typed).
// The server applies the same rule (bv_backend/Helper/phone.js), so what is checked here is what will be stored.

const MOBILE_LENGTH = 10;

// Digits only, at most 10. A number pasted with its prefix ("+91 98765 43210", "0 98765 43210", "919876543210")
// is reduced to the 10 digits, so pasting from a contact card just works.
export const cleanMobile = (value) => {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.length >= MOBILE_LENGTH + 2 && digits.startsWith('91')) digits = digits.slice(2);
  else if (digits.length >= MOBILE_LENGTH + 1 && digits.startsWith('0')) digits = digits.slice(1);
  return digits.slice(0, MOBILE_LENGTH);
};

// Indian mobile numbers are 10 digits and start with 6, 7, 8 or 9.
export const isValidMobile = (digits) => /^[6-9]\d{9}$/.test(String(digits ?? ''));

// What to tell the person, or '' when the number is fine or still being typed with nothing wrong so far.
// `finished` = they have left the field / pressed continue, so "too short" is worth mentioning.
export const mobileError = (digits, { finished = false } = {}) => {
  const value = String(digits ?? '');
  if (!value) return finished ? 'Enter your 10-digit mobile number' : '';
  if (!/^[6-9]/.test(value)) return 'A mobile number starts with 6, 7, 8 or 9';
  if (value.length < MOBILE_LENGTH && finished) return `Enter all 10 digits (you have entered ${value.length})`;
  return '';
};

export { MOBILE_LENGTH };
